import { App, DeepLinker, NavController, UrlSerializer, ViewController } from "ionic-angular";
import { NavOptions, NavSegment, Page } from "ionic-angular/navigation/nav-util";
import { Injectable } from "@angular/core";
import { EventService } from "../services/event.service";
import { NavigationParams } from "../app/app.interfaces";
import { Observable } from "rxjs/Observable";

@Injectable()
export class NavigationHelper {
  
  private nav: NavController;
  private pathHistory: string[] = [];
  
  private appLoaded: boolean = false;
  
  public activeComponent: Observable<string>;
  private activeComponentObserver: any;
    
  constructor(private app: App, private urlSerializer: UrlSerializer, private eventService: EventService, private deepLinker: DeepLinker) {
        
    this.activeComponent = new Observable<string>((observer) => {       
      this.activeComponentObserver = observer;
    });
    
    this.setNav();   

    window.onhashchange = (() => {
      let path = location.hash.substring(2);
      this.pathHistory.push(path);      
      this.pathHistory = this.pathHistory.slice(Math.max(this.pathHistory.length-5,0)); //Only remember last 5
			eventService.pathChanged.emit(path);
    });
    
    if(location.hash.length) this.pathHistory.push(location.hash);
    
    
  }
  
  
  
  
  public forcePathChangeUpdate(){
    this.eventService.pathChanged.emit(this.currentPath);
  }
  
  public getNav(name: string){
    return this.app.getNavByIdOrName(name) as NavController;
  }
  
  private setNav(){
    if(! this.nav){      
      let nav = this.app.getNavByIdOrName('rootNav') as NavController;
      if(nav){
        this.nav = nav;

        this.nav.viewDidEnter.subscribe((controller: ViewController) => {
        	// console.log('New active component: '+controller.component.name);
        	this.eventService.componentActivated.emit(controller.component.name);
        	if(this.activeComponentObserver) this.activeComponentObserver.next(controller.component.name);
				})
      }
      else {
        setTimeout(() => {
          this.setNav();
        },20);
      }
    }
  }
  
  public pushWithLocationUpdate(href: string, page: Page | string, params?: any): Promise<any>
  {
    if(href===null) {
      href = this.generatePath(page, params);
    }     
    let opts: NavOptions = { };      
    // console.log(href);
    this.deepLinker._updateLocation(href, 'switch');
    return this.nav.push(page, params, opts);
  }
  
  public updateLocation(href?: string, page?: Page | string, params?: any, direction: string = 'forward', ){
    
    if(href===null) {
      href = this.generatePath(page, params);
    } 
    this.deepLinker._updateLocation(href, direction);    
    
  }
  
  public currentComponentIs(component: any){
    return this.activeComponentIs(component);
  }
  
  public activeComponentIs(component: any){
    if(!this.nav.getActive() || ! this.nav.getActive().component) {
      return false;
    }
    let componentName;
    
    if(typeof component !== 'string') componentName = component.name;
    else componentName = component;
    
    return (this.nav.getActive().component.name === componentName);
    
  }
  
  
  
  
  public popWithLocationUpdate(popTo: string = null){
    
    if(popTo) {
      if(popTo==='dashboard') {
        
        let navOpts: NavOptions = {
          updateUrl: true,
          isNavRoot: true,
          keyboardClose: true,
          direction: 'back'
        };
        
        this.nav.popToRoot(navOpts).then(() => {
          //this.deepLinker.navChange('back');
        })        
      }
      else {
        this.nav.popTo(popTo).then(() => {
          this.deepLinker.navChange('back');
        })
      }
    }
    else {
      this.nav.pop().then(() => {
        this.deepLinker.navChange('back');
      })
    }
  }
  
  
  public getRootNav(): NavController {
    return this.nav;
  }
  
  public generatePathFromNavigationParams(navigationParams: NavigationParams): string {
    return this.generatePath(navigationParams.route, navigationParams.params, navigationParams.parentRoute, navigationParams.parentParams);
  }
    
  public generatePath(route: any, params: any = null, parentRoute: any = null, parentParams: any = null): string {

    if(!this.nav || !route) return null;
    
    //Create the navSegment for the route
    let navSegment = this.urlSerializer.createSegmentFromName(this.nav, route);    
    if(navSegment===null){
      return null;
    }
    let parsedUrlComponents = NavigationHelper.parseNavSegment(navSegment, params);
        
    if(parentRoute) {      
      let parentRouteSegment = this.urlSerializer.createSegmentFromName(this.nav, parentRoute);
      const parentParsedUrlComponents = NavigationHelper.parseNavSegment(parentRouteSegment, parentParams);
      parsedUrlComponents = [...parentParsedUrlComponents, ...parsedUrlComponents];  
    }
    
    return NavigationHelper.urlComponentsToHash(parsedUrlComponents);    
  }
  
  
  
  public canPop(): boolean {
    return this.nav.canGoBack();
  }
  
    
  
  public get currentPath(): string {
    return location.hash.substring(2);
  }
  
  private static urlComponentsToHash(urlComponents: string[]) {
    return urlComponents.join('/');    
  }
  
  private static parseNavSegments(navSegments: NavSegment[]){
    
    let parsedUrlComponents = [];
    for(let navSegment of navSegments){
      parsedUrlComponents.push(NavigationHelper.parseNavSegment(navSegment));
    }
    
    return NavigationHelper.urlComponentsToHash(parsedUrlComponents);
    
  }
    
  private static parseNavSegment(navSegment: NavSegment, params: any = null): any
  {
    let parsedUrlComponents = [];
    
    //Create the navSegment for the route
    let urlComponents = navSegment.id.split("/");
    
    //Replace the variable urlComponents with the provided param
    for (let urlComponent of urlComponents) {
      if(urlComponent.substr(0,1)===':') {
        let paramName = urlComponent.substr(1);
        if(params !== null && params[paramName] !== undefined) {
          parsedUrlComponents.push(params[paramName]);
        }
        else {
          console.error('Param '+paramName+' not defined');
        }
      }
      else {
        parsedUrlComponents.push(urlComponent);
      }
    }    
    return parsedUrlComponents;
    
  }
  
  
  
}


// WEBPACK FOOTER //
// ./src/helpers/navigation.helper.ts